import {Delete, POST} from "../util";

const inspectionUrl = "api/api-key-inspection";
const operationUrl = "api/api-key-operation";

const url = {
    inspection: {
        list: `${inspectionUrl}/list`,
    },
    operation: {
        createNewKey: `${operationUrl}/create`,
        updateKey: `${operationUrl}/update`,
        deleteKey: `${operationUrl}/delete/:id`,
    }

};

const apiKeysApi = {
    inspection: {
        list: (data) => {
            return POST(url.inspection.list, data);
        }
    },
    operation: {
        createNewKey: (data) => {
            return POST(url.operation.createNewKey, data);
        },
        updateKey: (data) => {
            return POST(url.operation.updateKey, data);
        },
        deleteKey: (id) => {
            return Delete(url.operation.deleteKey.replace(":id", id));
        }
    }
};
export {
    apiKeysApi
};